module.exports = __webpack_public_path__ + "img/Brachypodium_distachyon.3d339773.jpg";